module.exports = __webpack_public_path__ + "img/66.3.TP.3a02f02a.png";